<template>
	<div class="flex-1 flex flex-col">
		<fetch-json :url="`jobs/${jobId}/templates`" method="get" :params="{}">
			<template slot-scope="{ data: response, loading }">
				<div v-if="loading" class="text-grey-darker">
					Loading...
				</div>
				<div class="flex-1 m-2" v-else>
					<div class="flex justify-between mb-4">
						<h1 class="text-gray-700 text-xl mb-2 sm:text-2xl leading-none">
							Templates {{ response.job.name }}
						</h1>
						<div class="text-right leading-tight">
							<span class="block text-black">black - forecast</span>
							<span class="block text-red-500">red - ordered</span>
						</div>
						
					</div>
					<div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
						<div class="border rounded text-sm" v-for="template in response.templates" :key="template.id">
							<div class="flex justify-between px-1 py-2 bg-gray-200">
								<h4 class="">{{ template.name }} - x{{ template.units.length }} </h4>
								<div class="text-sm text-black">
									(<span v-text="template.units.filter(unit => {return unit.status == 'started' && unit.forecast_done == 'y'}).length"></span>,
									<span class="text-red-500" v-text="template.units.filter(unit => {return unit.status == 'started' && unit.order_done == 'y'}).length"></span>)
								</div>
								
							</div>
							<h4 class="text-xs font-normal px-1 pb-2 bg-gray-200">
								<span class="inline-block mr-1" v-for="unit in template.units" v-if="unit.status == 'started' && unit.forecast_done == 'y'" :class="[unit.order_done == 'y' ? 'text-red-500' : '']">{{ unit.name }}</span>
							</h4>
							<div class="grid grid-cols-6 gap-1 text-black px-2 pb-1 border-b my-1" v-for="product in template.products">
								<div class="col-span-5">{{ product.name }}</div>
								<div class="text-right">{{ product.pivot.allocated }}</div>
							</div>
						</div>						
					</div>
				</div>
			</template>
		</fetch-json>
	</div>
</template>

<script>
	export default {

		name: 'ShowTemplates',

		data () {
			return {

			}
		},
		computed: {
			jobId: function () {
				return this.$route.params.id;
			}
		},
		created: function () {
			//this.$store.commit('setJobName', this.job.name)
		}
	}
</script>

<style lang="css" scoped>
</style>